// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"styles-module__imageWrapper___2RZHe","img":"styles-module__img___348YJ"};